import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquarePhone } from '@fortawesome/free-solid-svg-icons/faSquarePhone';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { awesomeInstagram, awesomeLinkedin, awesomeFacebook } from '@layouts/footer/menu/customIcons';



const Menu = () => {

	return (
		<div className='footer-menu'>

			<div className='menu-headers'>
				<p>ControlTower</p>
				<p>Podpora a nastavení</p>
			</div>

			<div className='menu-links'>
				
				<div className='links-column'>
					<p className='active-link'>Přehled</p>
					<p>Úkoly</p>
					<p>Komunikace</p>
					<p>Systémy</p>
					<p>Dokumenty</p>
					<p>Postupy</p>
					<p>Zákazníci</p>
					<p>Výrobky</p>
				</div>
				
				<div className='links-column'>
					<p>Přehled</p>
					<p>Úkoly</p>
					<p>Komunikace</p>
					<p>Systémy</p>
					<p>Dokumenty</p>
					<p>Postupy</p>
					<p>Zákazníci</p>
					<p>Výrobky</p>
				</div>

			</div>

			<div className='menu-icons'>
				
				<div className='left-side'>
					<FontAwesomeIcon icon={faSquarePhone} />
					<FontAwesomeIcon icon={faEnvelope} />
				</div>
				
				<div className='right-side'>
					<FontAwesomeIcon icon={awesomeFacebook} />
					<FontAwesomeIcon icon={awesomeLinkedin} />
					<FontAwesomeIcon icon={awesomeInstagram} />
				</div>
			</div>
		
		</div>
	);
}

export default Menu;